
import { titleCaseKey } from "@/components/odds-screen/live/labels";
import type { OverUnder } from "@/components/optimizer/query-state";

export function isYesNoSide(side: string | null | undefined): boolean {
  const normalized = (side ?? "").toUpperCase();
  return normalized === "YES" || normalized === "NO";
}

const OVER_SLOT_SIDES = new Set(["OVER", "HOME", "YES"]);
const UNDER_SLOT_SIDES = new Set(["UNDER", "AWAY", "NO"]);

export function isOverSlotSide(side: string | null | undefined): boolean {
  return OVER_SLOT_SIDES.has((side ?? "").toUpperCase());
}

export function isUnderSlotSide(side: string | null | undefined): boolean {
  return UNDER_SLOT_SIDES.has((side ?? "").toUpperCase());
}

export function matchesOverUnder(side: string, overUnder: OverUnder): boolean {
  return overUnder === "" || side.toLowerCase() === overUnder;
}

export function outcomeLabel(side: string | null | undefined): string | null {
  return !side || isOverSlotSide(side) || isUnderSlotSide(side) ? null : titleCaseKey(side);
}

export function formatSideLabel(side: string | null | undefined): string {
  const raw = side ?? "";
  switch (raw.toUpperCase()) {
    case "OVER":
      return "Over";
    case "UNDER":
      return "Under";
    case "HOME":
      return "Home";
    case "AWAY":
      return "Away";
    case "YES":
      return "Yes";
    case "NO":
      return "No";
    default:
      return raw;
  }
}
